(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["osakeda-direct-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('osakeda-direct-buy')) {
  customElements.define('osakeda-direct-buy', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.scope = this.closest('[data-section-type="product"]');
      this.button = this.querySelector('button');
      this.hint = this.querySelector('[data-direct-buy-hint]');
      if (!this.form || !this.scope || !this.button) return;
      this.busy = false;
      this.onChange = () => this.sync();
      this.onPageShow = (event) => {
        this.busy = false;
        if (event.persisted) {
          const method = this.scope.querySelector('select[name^="ssdp__delivery-method-input-field-"]');
          method?.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.sync();
      };
      this.onClick = (event) => {
        event.preventDefault();
        const selection = this.readSelection();
        if (this.busy || !selection || this.button.disabled) return;
        if (!this.form.reportValidity()) return;
        const url = this.buildCheckoutUrl(selection);
        if (!url) return;
        this.busy = true;
        this.sync();
        window.location.assign(url.href);
      };
      this.button.addEventListener('click', this.onClick);
      this.scope.addEventListener('change', this.onChange, true);
      window.addEventListener('pageshow', this.onPageShow);
      this.observer = new MutationObserver(this.onChange);
      this.observer.observe(this.scope, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'disabled', 'value']
      });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      this.scope?.removeEventListener('change', this.onChange, true);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    readSelection() {
      const input = this.scope.querySelector('input[name^="ssdp__date-input-field-"]');
      const instance = input?.closest('.ssdp__instance');
      if (!input?.value.trim()) return { date: '', method: '', time: '' };
      if (!instance) return null;
      const method = instance.querySelector('select[name^="ssdp__delivery-method-input-field-"]');
      const time = instance.querySelector('select[name^="ssdp__time-input-field-"]');
      if (!method?.value) return null;
      if (time?.getClientRects().length && !time.value) return null;
      return {
        date: input.value.trim(),
        method: method.value,
        time: time?.getClientRects().length ? time.value : ''
      };
    }

    sync() {
      const selection = this.readSelection();
      const addButton = this.form.querySelector('[data-add-to-cart]');
      const variant = this.form.querySelector('input[name="id"]');
      const disabled = this.busy || !selection || !variant?.value || !addButton || addButton.disabled;
      if (this.button.disabled !== Boolean(disabled)) this.button.disabled = Boolean(disabled);
      const label = this.busy ? this.dataset.loadingLabel : this.dataset.buttonLabel;
      if (this.button.textContent !== label) this.button.textContent = label;
      const hideHint = Boolean(selection?.date);
      if (this.hint.hidden !== hideHint) this.hint.hidden = hideHint;
    }

    buildCheckoutUrl(selection) {
      const variant = this.form.querySelector('input[name="id"]')?.value;
      if (!/^\d+$/.test(variant || '')) return null;
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(root + 'cart/' + variant + ':1', window.location.origin);
      url.searchParams.set('attributes[Delivery Date]', selection.date);
      url.searchParams.set('attributes[Delivery Method]', selection.method);
      url.searchParams.set('attributes[Delivery Time]', selection.time);
      const properties = {};
      for (const [name, value] of new FormData(this.form)) {
        const match = /^properties\[(.+)\]$/.exec(name);
        if (match && typeof value === 'string' && value) properties[match[1]] = value;
      }
      if (selection.date) {
        properties[this.dataset.dateProperty] = selection.date;
      } else {
        delete properties[this.dataset.dateProperty];
      }
      let binary = '';
      for (const byte of new TextEncoder().encode(JSON.stringify(properties))) {
        binary += String.fromCharCode(byte);
      }
      url.searchParams.set('properties', btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/, ''));
      url.search = url.searchParams.toString().replaceAll('+', '%20');
      return url;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
